import { Stack } from '@chakra-ui/react';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BrightnessFilterMenuItem } from '$/components/core/Collection/CollectionFilter/components/BrightnessFilter/BrightnessFilterMenuItem';
import { FilterActions } from '$/components/core/Collection/CollectionFilter/components/FilterActions';
import { TooltipLabel } from '$/pages/DashboardPages/components/TooltipLabel';
import { useCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  onMenuClose: () => void;
}

export const BrightnessFilter: FC<Props> = ({ onMenuClose }) => {
  const { t } = useTranslation();

  const [brightnessFilter, setBrightnessFilter] = useState(
    useCollectionStore.getState().brightnessFilter,
  );

  const [activeChanges, setActiveChanges] = useState(false);

  const handleReset = () => {
    useCollectionStore.getState().setBrightnessFilter([0, 100]);
    setActiveChanges(true);
    onMenuClose();
  };

  const handleSubmit = () => {
    useCollectionStore.getState().setBrightnessFilter(brightnessFilter);
    setActiveChanges(false);
    onMenuClose();
  };

  return (
    <>
      <BrightnessFilterMenuItem
        onBrightnessChange={(val) => {
          setActiveChanges(true);
          setBrightnessFilter(val);
        }}
      />
      <Stack gap='4' p='3'>
        <TooltipLabel
          label={t('dashboard.collection.whatIsBrightness')}
          info={t('dashboard.collection.brightnessExplanation')}
        />
        <FilterActions
          anyFilterActive={
            brightnessFilter[0] !== 0 || brightnessFilter[1] !== 100
          }
          activeChanges={activeChanges}
          onSubmit={handleSubmit}
          onReset={handleReset}
        />
      </Stack>
    </>
  );
};
